/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Sidebar_Multiselect_DescriptionInputs */

const es_walkthrough_sidebar_multiselect_description = /** @type {(inputs: Walkthrough_Sidebar_Multiselect_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantené Shift y hacé clic para seleccionar un rango de chats y eliminalos todos juntos. Pasá el mouse por encima de un chat para acceder a sus acciones individuales.`)
};

const en_walkthrough_sidebar_multiselect_description = /** @type {(inputs: Walkthrough_Sidebar_Multiselect_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hold Shift and click to select a range of chats and delete them all at once. Hover over a chat to access its individual actions.`)
};

/**
* | output |
* | --- |
* | "Hold Shift and click to select a range of chats and delete them all at once. Hover over a chat to access its individual actions." |
*
* @param {Walkthrough_Sidebar_Multiselect_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_sidebar_multiselect_description = /** @type {((inputs?: Walkthrough_Sidebar_Multiselect_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Sidebar_Multiselect_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_sidebar_multiselect_description(inputs)
	return en_walkthrough_sidebar_multiselect_description(inputs)
});
export { walkthrough_sidebar_multiselect_description as "walkthrough.sidebar_multiselect_description" }